export enum DocumentState {
  CONTRACT_DRAFT = 'CONTRACT_DRAFT', // The document is generated from a draft contract
  AGREEMENT_DRAFT = 'AGREEMENT_DRAFT', // The document is generated from a draft agreement (partners contract)
  DRAFT = 'DRAFT', // The document is before its issue date
  REVIEW_MISSING_DATA = 'REVIEW_MISSING_DATA', // The document issue date had arrived but some data is missing (usage report, etc.)
  REVIEW_READY_TO_SEND = 'REVIEW_READY_TO_SEND', // The document issue date had arrived and all data is present
  COLLECTING_INFO = 'COLLECTING_INFO', // The document is in the process of collecting data (aggregating multiple invoices/payments, such as due upon usage)
  PAYMENT_FAILED_COLLECTING_INFO = 'PAYMENT_FAILED_COLLECTING_INFO', // The document is in the process of collecting data but one of the payments failed
  OPEN = 'OPEN', // The document is open, used by adjustment credit notes when balance is not exhausted
  FINALIZED = 'FINALIZED', // The document is "sealed" and ready for auto-charge
  SENT = 'SENT', // The document was sent to the customer
  SENT_FAILED = 'SENT_FAILED', // The document failed to be sent to the customer
  LATE = 'LATE', // The document due date had passed and the document is not paid
  PAID = 'PAID', // The document was fully paid
  PAYMENT_FAILED = 'PAYMENT_FAILED', // The document payment failed
  CANCELED = 'CANCELED', // The document was canceled and will not be issued
}
